import React, { useEffect, useState } from "react";
import { injectIntl, defineMessages } from "react-intl";
import LiveChat from "./LiveChat";
import PropTypes from 'prop-types';
import isEmpty from "lodash.isempty";
import { getCookieConsentValue } from "react-cookie-consent";
import CookieConsent from "./CookieConsent";

export const messages = defineMessages({
    toggleChat: {
        id: "Avaa Chat",
        defaultMessage: "Avaa Chat"
    }
});

/**
 * Add disabled class to chatbuttons.
 * 
 * @param menuChatButton
 * @param supportMenuChatButton
 */
export function disableChatButtons(menuChatButton, supportMenuChatButton) {

    if (!isEmpty(supportMenuChatButton)) {
        supportMenuChatButton.classList.add('listbutton-disabled');
    }
    if (!isEmpty(menuChatButton)) {
        menuChatButton.classList.add('listbutton-disabled-menu');
    }
}

/**
 * Remove disabled class from chatbuttons.
 * 
 * @param menuChatButton
 * @param supportMenuChatButton
 */
export function showChatButtons(menuChatButton, supportMenuChatButton) {

    if (!isEmpty(supportMenuChatButton)) {
        supportMenuChatButton.classList.remove('listbutton-disabled');
    }
    if (!isEmpty(menuChatButton)) {
        menuChatButton.classList.remove('listbutton-disabled-menu');
    }
}


const ToggleChatButton = (props) => {
    const lng = props.intl.formatMessage;
    const liveChatLicenseId = process.env.REACT_APP_LIVECHAT_LICENSE_ID;
    const liveChatParameters = props.parameters;
    const liveChatVisitor = props.visitor;
    const [isChatOpen, setIsChatOpen] = useState(false);

    useEffect(() => {
        const supportMenuChatButton = document.querySelector('#toggle-chat-window');
        const menuChatButton = document.querySelector('#toggle-chat-menu');

        // disable chat buttons, if chat is open, or cookie consent has not been accepted
        if (document.getElementById('chat-widget-container') || getCookieConsentValue() === undefined || getCookieConsentValue() === false || isChatOpen) {
            disableChatButtons(menuChatButton, supportMenuChatButton);
        } else {
            showChatButtons(menuChatButton, supportMenuChatButton);
        }
    });

    /**
     * Open chat, if cookies have been accepted.
     */
    function cookiesUpdated() {
        if (getCookieConsentValue()) {
            setIsChatOpen(true);
        } else {
            setIsChatOpen(false);
        }
    }


    return (
        <>
            <CookieConsent
                openedFrom={props.location === 'menu' ? 'menu' : 'invoice'}
                buttonId={props.location === 'menu' ? 'toggle-chat-menu' : 'toggle-chat-window'}
                buttonTitle={lng(messages.toggleChat)}
                buttonStyling={`btn actionlist-button ${props.location === 'menu' ? 'btn-tertiary-menu' : 'btn-tertiary'}`}
                buttonText={lng(messages.toggleChat)}
                popoverStyling={'menu-popover'}
                cookiesUpdated={cookiesUpdated}
                {...props}
            />
            {isChatOpen && (
                <LiveChat
                    id="livechat"
                    license={liveChatLicenseId}
                    visitor={liveChatVisitor}
                    params={liveChatParameters}
                />
            )}
        </>
    )
};

ToggleChatButton.propTypes = {
    'intl': PropTypes.object.isRequired,
    'parameters': PropTypes.any,
    'visitor': PropTypes.any,
    'location': PropTypes.string,
};

export default injectIntl(ToggleChatButton);